'use client';

import { PropsWithChildren, createContext, useState } from 'react';

type NotificationProviderData = {
  showReminder: (v: 'notification' | 'pwa') => void;
  hideReminder: (v: 'notification' | 'pwa') => void;
  open: boolean;
  type: 'notification' | 'pwa';
};

const initialData: NotificationProviderData = {
  showReminder: () => {},
  hideReminder: () => {},
  open: false,
  type: 'notification',
};

export const NotificationContext = createContext(initialData);

export const NotificationProvider: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const [open, setOpen] = useState(false);
  const [shownNotification, setShownNotification] = useState(false);
  const [shownPwa, setShownPwa] = useState(false);
  const [type, setType] = useState<'notification' | 'pwa'>('pwa');

  const showReminder = (t: 'notification' | 'pwa') => {
    const shown = t === 'notification' ? shownNotification : shownPwa;
    if (shown) return;
    setType(t);
    setOpen(true);
    if (t === 'notification') setShownNotification(true);
    else setShownPwa(true);
  };

  const hideReminder = (t: 'notification' | 'pwa') => {
    setOpen(false);
    if (t === 'notification') setShownNotification(true);
    else setShownPwa(true);
  };

  return (
    <NotificationContext.Provider
      value={{
        showReminder,
        open,
        hideReminder,
        type,
      }}
    >
      {children}
    </NotificationContext.Provider>
  );
};
